// Shared "picker mode" contract used by creation pages opened from a CreatableSelect.
// When a creation page is opened in a new tab from a CreatableSelect it carries `?picker=1`.
// On save it notifies the opener (the parent tab) with the created entity and closes itself.

const MESSAGE_SOURCE = 'creatable-select'

export function isPickerMode(route) {
    return route && route.query && route.query.picker === '1'
}

// Notifies the opener with the created entity and closes the tab.
// `payload` must include the client-generated uuid (the same token the parent used).
// Returns true when the notification was sent and the tab will close; false otherwise
// (so the caller can keep its usual navigation as a fallback).
export function notifyCreatedAndClose(payload) {
    if (!window.opener) return false

    window.opener.postMessage(
        { source: MESSAGE_SOURCE, payload },
        window.location.origin
    )
    window.close()
    return true
}
